var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.visible
    ? _c(
        "div",
        { staticClass: "emap-flow-next-step" },
        [
          _vm.cur_node_info.nodeName
            ? _c("div", { staticClass: "emap-flow-next-step-item" }, [
                _c("label", { staticClass: "emap-flow-item-label" }, [
                  _vm._v(_vm._s(_vm.labels.cur_node)),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "emap-flow-item-content" }, [
                  _c("div", { staticClass: "next-node-desc" }, [
                    _vm._v(_vm._s(_vm.cur_node_info.nodeName)),
                  ]),
                ]),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.cur_node_info.documentation
            ? _c("div", { staticClass: "emap-flow-next-step-item" }, [
                _c("label", { staticClass: "emap-flow-item-label" }, [
                  _vm._v(_vm._s(_vm.labels.cur_node_desc)),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "emap-flow-item-content" }, [
                  _c("div", { staticClass: "next-node-desc" }, [
                    _vm._v(_vm._s(_vm.cur_node_info.documentation)),
                  ]),
                ]),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.showNextNode
            ? _c("div", { staticClass: "emap-flow-next-step-item" }, [
                _c("label", { staticClass: "emap-flow-item-label" }, [
                  _vm._v(_vm._s(_vm.nodelabel || _vm.labels.node)),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "emap-flow-item-content" },
                  [
                    _c(
                      "Select",
                      {
                        ref: "nextNode",
                        attrs: {
                          disabled: _vm.node_list.length === 1,
                          loading: _vm.loading,
                          transfer: "",
                          placeholder: _vm.nodeplaceholder,
                        },
                        on: {
                          "on-change": _vm.$_nodeChange,
                          "on-open-change": _vm.$_getCustomNode,
                          "on-query-change": function ($event) {
                            return _vm.queryChange("nextNode")
                          },
                        },
                        model: {
                          value: _vm.node,
                          callback: function ($$v) {
                            _vm.node = $$v
                          },
                          expression: "node",
                        },
                      },
                      _vm._l(_vm.node_list, function (item) {
                        return _c(
                          "Option",
                          { key: item.nodeId, attrs: { value: item.nodeId } },
                          [_vm._v(_vm._s(item.nodeName))]
                        )
                      }),
                      1
                    ),
                  ],
                  1
                ),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.showNextNode &&
          _vm.cur_node.documentation &&
          _vm.schema === "default"
            ? _c("div", { staticClass: "emap-flow-next-step-item" }, [
                _c("label", { staticClass: "emap-flow-item-label" }, [
                  _vm._v(_vm._s(_vm.labels.node_desc)),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "emap-flow-item-content" }, [
                  _c("div", { staticClass: "next-node-desc" }, [
                    _vm._v(_vm._s(_vm.cur_node.documentation)),
                  ]),
                ]),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.$slots.customItem
            ? _c(
                "div",
                { staticClass: "emap-flow-next-step-item" },
                [_vm._t("customItem")],
                2
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.cur_node.isEndNode !== "1" &&
          _vm.showNextAssignees &&
          !_vm.isMultiInstance
            ? _c("div", { staticClass: "emap-flow-next-step-item" }, [
                _c("label", { staticClass: "emap-flow-item-label" }, [
                  _vm._v(_vm._s(_vm.assigneeslabel || _vm.labels.assignee)),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "emap-flow-item-content" },
                  [
                    _vm.assignee_list.length && _vm.echostyle != "tree"
                      ? _c(
                          "Select",
                          {
                            ref: "nextAssignees",
                            attrs: {
                              disabled: !_vm.cur_node.nodeId,
                              placeholder: _vm.assigneeplaceholder,
                              multiple: _vm.multiple,
                              transfer: "",
                              filterable: "",
                              clearable: "",
                            },
                            on: {
                              "on-change": _vm.emitInput,
                              "on-query-change": function ($event) {
                                return _vm.queryChange("nextAssignees")
                              },
                            },
                            model: {
                              value: _vm.assignees,
                              callback: function ($$v) {
                                _vm.assignees = $$v
                              },
                              expression: "assignees",
                            },
                          },
                          _vm._l(_vm.assignee_list, function (item) {
                            return _c(
                              "Option",
                              {
                                key: item.userId,
                                attrs: { value: item.userId },
                              },
                              [_vm._v(_vm._s(item.display))]
                            )
                          }),
                          1
                        )
                      : _c(
                          "div",
                          {
                            staticClass: "custom-next-asssignees-select",
                            class: [
                              {
                                disabled:
                                  !_vm.cur_node.nodeId && _vm.showNextNode,
                              },
                            ],
                            on: { click: _vm.$_customSelect },
                          },
                          _vm._l(
                            _vm.customNextAssigneesList,
                            function (item, index) {
                              return _c(
                                "Tag",
                                {
                                  key: index,
                                  attrs: { closable: "", name: item.id },
                                  on: {
                                    "on-close": function ($event) {
                                      return _vm.$_customOptionClose(
                                        item,
                                        index
                                      )
                                    },
                                  },
                                },
                                [_vm._v(_vm._s(item.display))]
                              )
                            }
                          ),
                          1
                        ),
                  ],
                  1
                ),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.cur_node.isEndNode !== "1" &&
          _vm.showNextAssignees &&
          !_vm.isMultiInstance &&
          _vm.allowAddAssignee &&
          !_vm.addAssigneeHidden
            ? _c("div", { staticClass: "emap-flow-next-step-item" }, [
                _c("label", { staticClass: "emap-flow-item-label" }, [
                  _vm._v(_vm._s(_vm.labels.addAssignee)),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "emap-flow-item-content" }, [
                  _c(
                    "div",
                    {
                      staticClass: "custom-next-asssignees-select",
                      class: [
                        { disabled: !_vm.cur_node.nodeId && _vm.showNextNode },
                      ],
                      on: { click: _vm.clickAddAssignee },
                    },
                    _vm._l(_vm.addAssigneesList, function (item, index) {
                      return _c(
                        "Tag",
                        {
                          key: index,
                          attrs: { closable: "", name: item.id },
                          on: {
                            "on-close": function ($event) {
                              return _vm.$_addOptionClose(item, index)
                            },
                          },
                        },
                        [_vm._v(_vm._s(item.display))]
                      )
                    }),
                    1
                  ),
                ]),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.cur_node.isEndNode !== "1" &&
          _vm.showNextAssignees &&
          _vm.isMultiInstance
            ? _c("div", { staticClass: "emap-flow-next-step-item" }, [
                _c("label", { staticClass: "emap-flow-item-label" }, [
                  _vm._v(_vm._s(_vm.labels.assigneeGroup)),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "emap-flow-item-content" },
                  [
                    _c(
                      "Select",
                      {
                        ref: "nextAssignees",
                        attrs: {
                          disabled: !_vm.cur_node.nodeId,
                          placeholder: _vm.assigneeplaceholder,
                          multiple: "",
                          transfer: "",
                          filterable: "",
                          clearable: "",
                        },
                        on: {
                          "on-change": _vm.emitInput,
                          "on-query-change": function ($event) {
                            return _vm.queryChange("nextAssignees")
                          },
                        },
                        model: {
                          value: _vm.assignees,
                          callback: function ($$v) {
                            _vm.assignees = $$v
                          },
                          expression: "assignees",
                        },
                      },
                      _vm._l(_vm.assignee_list, function (item) {
                        return _c(
                          "Option",
                          { key: item.userId, attrs: { value: item.userId } },
                          [_vm._v(_vm._s(item.display))]
                        )
                      }),
                      1
                    ),
                  ],
                  1
                ),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.hasCirculate
            ? _c("div", { staticClass: "emap-flow-next-step-item" }, [
                _c("label", { staticClass: "emap-flow-item-label" }, [
                  _vm._v(_vm._s(_vm.labels.circulator)),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "emap-flow-item-content" },
                  [
                    _vm.circulatorSelectFalg
                      ? _c(
                          "Select",
                          {
                            attrs: {
                              placeholder: _vm.$LocalH5(
                                "nextStep.selectPlaceholder"
                              ),
                              multiple: "",
                              transfer: "",
                              filterable: "",
                              clearable: "",
                            },
                            on: { "on-change": _vm.emitInput },
                            model: {
                              value: _vm.circulators,
                              callback: function ($$v) {
                                _vm.circulators = $$v
                              },
                              expression: "circulators",
                            },
                          },
                          _vm._l(_vm.circulator_list, function (item) {
                            return _c(
                              "Option",
                              {
                                key: item.userId,
                                attrs: { value: item.userId },
                              },
                              [_vm._v(_vm._s(item.display))]
                            )
                          }),
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    !_vm.circulatorSelectFalg
                      ? _c(
                          "div",
                          {
                            staticClass: "custom-next-asssignees-select",
                            on: { click: _vm.$_customCirculatorSelect },
                          },
                          _vm._l(
                            _vm.customCirculatorList,
                            function (item, index) {
                              return _c(
                                "Tag",
                                {
                                  key: index,
                                  attrs: { closable: "", name: item.id },
                                  on: {
                                    "on-close": function ($event) {
                                      return _vm.$_customCirculatorLOptionClose(
                                        item,
                                        index
                                      )
                                    },
                                  },
                                },
                                [_vm._v(_vm._s(item.display))]
                              )
                            }
                          ),
                          1
                        )
                      : _vm._e(),
                  ],
                  1
                ),
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("emap-flow-pick", {
            attrs: {
              multiple: _vm.multiple,
              options: _vm.assignees,
              users: _vm.assignee_list,
              filter: _vm.echostyle === "tree",
            },
            on: { "on-confirm": _vm.$_emapflowPick },
            model: {
              value: _vm.showpick,
              callback: function ($$v) {
                _vm.showpick = $$v
              },
              expression: "showpick",
            },
          }),
          _vm._v(" "),
          _c("emap-flow-pick", {
            attrs: { multiple: _vm.multiple, options: _vm.assigneesAdd },
            on: { "on-confirm": _vm.configAddAssignee },
            model: {
              value: _vm.showpickAdd,
              callback: function ($$v) {
                _vm.showpickAdd = $$v
              },
              expression: "showpickAdd",
            },
          }),
          _vm._v(" "),
          _c("emap-flow-pick", {
            attrs: { multiple: "", options: _vm.circulators },
            on: { "on-confirm": _vm.$_emapflowPick },
            model: {
              value: _vm.showcirculatorpick,
              callback: function ($$v) {
                _vm.showcirculatorpick = $$v
              },
              expression: "showcirculatorpick",
            },
          }),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }